import request from "lib/request"
import swal from "sweetalert2"
import { showErrorWithCode } from 'components/common'
export const CURRENT_USER_REQUEST = 'CURRENT_USER_REQUEST'
export const CURRENT_USER_REQUEST_ERROR = 'CURRENT_USER_REQUEST_ERROR'
export const CURRENT_USER_REQUEST_SUCCESS = 'CURRENT_USER_REQUEST_SUCCESS'
export const CURRENT_USER_FETCHING = 'CURRENT_USER_FETCHING'
export const IS_GET_API = 'IS_GET_API'
export const GET_LEVEL_INFO_SUCCESS = 'GET_LEVEL_INFO_SUCCESS'
export const CHOOSE_ROAD_SUCCESS = 'CHOOSE_ROAD_SUCCESS'
export const UPDATE_INFO_SUCCESS = 'UPDATE_INFO_SUCCESS'
export const CHECK_PROGRESS_SUCCESS = 'CHECK_PROGRESS_SUCCESS'
export const SHARE_FB_SUCCESS = 'SHARE_FB_SUCCESS'
export const SHARE_FACEBOOK = 'facebook.share'
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS'
export const CLAIM_MEDAL_SUCCESS = 'CLAIM_MEDAL_SUCCESS'
export const CLAIM_MISSION_SUCCESS = 'CLAIM_MISSION_SUCCESS'
export const CHECK_MISSION_SUCCESS = 'CHECK_MISSION_SUCCESS'
export const VOTE_TEAM_SUCCESS = 'VOTE_TEAM_SUCCESS'
export const CLAIM_STAGE_SUCCESS = 'CLAIM_STAGE_SUCCESS'
export const RELOAD_SUCCESS = 'RELOAD_SUCCESS'

export const isGetApi = () => {
  return {
    type: IS_GET_API
  }
}
//user
export const isCurrentUserFetching = () => {
  return {
    type: CURRENT_USER_FETCHING
  }
}
export const getCurrentUser = () => {
  return (dispatch, getState) => {
    dispatch(isCurrentUserFetching());
    request('api/user/get').then(function (response) {
      if (response.status == 'successful') {
        dispatch(getCurrentUserSuccess(response));
        if (!response.payload.user.account_id) {
          swal({
            title: 'Thông báo',
            html: '<p class="pop-content">Bạn chưa tạo HLV, vui lòng tạo HLV rồi quay lại.</p>',
            animation: false,
            confirmButtonText: 'Đóng',
            customClass: 'custom-modal animated zoomIn'
          }).then((result) => {
            window.location.href = "/user/logout"
          })
        }
      } else {
        dispatch(getCurrentUserError(response))
        if (response.error_code == 'error_account_not_found') {
          swal({
            title: 'Thông báo',
            html: '<p class="pop-content">Bạn chưa tạo HLV, vui lòng tạo HLV rồi quay lại.</p>',
            animation: false,
            confirmButtonText: 'Đóng',
            customClass: 'custom-modal animated zoomIn'
          }).then((result) => {
            window.location.href = "/user/logout"
          })
        }
      }
    })
  }
}
export const getCurrentUserSuccess = (response) => {
  return {
    type: CURRENT_USER_REQUEST_SUCCESS,
    payload: response.payload
  }
}
export const getCurrentUserError = (response) => {
  return {
    type: CURRENT_USER_REQUEST_ERROR,
    payload: response.payload
  }
}

//open card
export const chooseRoad = (week_way) => {
  return (dispatch, getState) => {
    dispatch(isGetApi());
    request('api/user/choose_road_type', 'POST', {
      body: JSON.stringify({
        week_way: week_way
      })
    }).then(function (response) {
      if (response.status == 'successful') {
        dispatch(chooseRoadSuccess(response))
        swal({
          title: 'CHÚC MỪNG BẠN',
          html: '<p class="pop-content">Chọn con đường thành công. Bạn có thể nhận nhiệm vụ</p><div class="img-pop-gift"></div>',
          animation: false,
          confirmButtonText: 'Đóng',
          customClass: 'custom-modal animated zoomIn'
        })
      } else {
        swal({
          title: 'Thông báo',
          html: '<p class="pop-content">' + showErrorWithCode(response.error_code) + '</p>',
          animation: false,
          confirmButtonText: 'Đóng',
          customClass: 'custom-modal animated zoomIn'
        })
      }
    })
  }
}
export const chooseRoadSuccess = (response) => {
  return {
    type: CHOOSE_ROAD_SUCCESS,
    payload: response.payload
  }
}
//get level
export const getHistory = () => {
  return (dispatch, getState) => {
    dispatch(isGetApi());
    request('api/user/history').then(function (response) {
      if (response.status == 'successful') {
        dispatch(getHistorySuccess(response));
      } else {
      }
    })
  }
}
export const getHistorySuccess = (response) => {
  return {
    type: GET_HISTORY_SUCCESS,
    payload: response.payload
  }
}
//check top up 
export const reloadFC = () => {
  return (dispatch, getState) => {
    dispatch(isGetApi());
    request('api/user/get_topup').then(function (response) {
      if (response.status == 'successful') {
        dispatch(reloadFCSuccess(response));
        swal({
          title: 'Thông báo',
          html: '<p class="pop-content">Cập nhật thành công.</p>',
          animation: false,
          confirmButtonText: 'Đóng',
          customClass: 'custom-modal animated zoomIn'
        })
      } else {
      }
    })
  }
}
export const reloadFCSuccess = (response) => {
  return {
    type: RELOAD_SUCCESS,
    payload: response.payload
  }
}
//claim point
export const calimMedal = (period_promotion_id,stage,callback) => {
  return (dispatch, getState) => {
    dispatch(isGetApi());
    request('api/user/claim', 'POST', {
      body: JSON.stringify({
        stage: stage,
        promotion_period_id: period_promotion_id,
      })
    }).then(function (response) {
      if (response.status == 'successful') {
        dispatch(calimMedalSuccess(response))
        callback()
      } else {
        swal({
          title: 'Thông báo',
          html: '<p class="pop-content">' + showErrorWithCode(response.error_code) + '</p>',
          animation: false,
          confirmButtonText: 'Đóng',
          customClass: 'custom-modal animated zoomIn'
        })
      }
    })
  }
}
export const calimMedalSuccess = (response) => {
  return {
    type: CLAIM_MEDAL_SUCCESS,
    payload: response.payload
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/modules/actions.js